import React from "react";
import PageShell from "../components/common/PageShell";
import SectionTwoHomePage from "../components/home/SectionTwoHomePage";
import SectionThreeHomPage from "../components/home/SectionThreeHomPage";
import SectionFourHomePage from "../components/home/SectionFourHomePage";
import ImageSlider from "../components/home/ImageSlider";
import LandingClients from "../components/landing/LandingClients";
import { useLandingPageData } from "../hooks/useLandingPageData";

function HomePage() {
  const { acf, resolveMedia } = useLandingPageData();

  return (
    <PageShell className="min-h-0 bg-[var(--caf-surface)]">
      <ImageSlider />
      <SectionTwoHomePage />
      <SectionThreeHomPage />
      <SectionFourHomePage />
      <LandingClients acf={acf} resolveMedia={resolveMedia} />
    </PageShell>
  );
}

export default HomePage;
